module.exports = __webpack_public_path__ + "img/skull_11_bj.22b48dc5.png";